module.exports = __webpack_public_path__ + "static/client20-295855789acf9d64a4961a6178883de7.png";